import { NavLink } from "react-router-dom";
import logo from "../assets/logo/logo-1.png";
import { RiComputerLine } from "react-icons/ri";
import "../styles/Accordion.css";

const Sidebar = () => {

  return (
    <div className="col-md-3 col-lg-2 d-md-block sidebar collapse">
      <div className="sidebar-logo">
        <NavLink to="/dashboard">
          <img src={logo} alt="Admin Logo" />
        </NavLink>
      </div>

      <div className="sidebar-links">
        <ul className="list-unstyled">
          <li>
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                isActive ? "active nav-link" : "nav-link"
              }
            >
              <span>Dashboard</span>
              <span>
                <RiComputerLine size={22} />
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/festival-type"
              className={({ isActive }) =>
                isActive ? "active nav-link" : "nav-link"
              }
            >
              <span>Festival Types</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/card"
              className={({ isActive }) =>
                isActive ? "active nav-link" : "nav-link"
              }
            >
              <span>Cards</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/carol"
              className={({ isActive }) =>
                isActive ? "active nav-link" : "nav-link"
              }
            >
              <span>Carols</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/sticker"
              className={({ isActive }) =>
                isActive ? "active nav-link" : "nav-link"
              }
            >
              <span>Stickers</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/wishes"
              className={({ isActive }) =>
                isActive ? "active nav-link" : "nav-link"
              }
            >
              <span>Wishes</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/playlists"
              className={({ isActive }) =>
                isActive ? "active nav-link" : "nav-link"
              }
            >
              <span>Playlists</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
